<template>
  <el-popover
    v-model="isShowPopover"
    :placement="placement"
    trigger="click"
    :popper-class="popoverClass"
  >
    <div v-for="(v , i) in btnOptions" :key="i" class="popover-btn" @click="handleClick(v)">{{ v.label }}</div>
    <span slot="reference" class="model-top-btn">
      <slot name="reference"></slot>
    </span>
  </el-popover>
</template>

<script>
import i18n from '@/lang';

export default {
  name: 'ItexPopover',
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    popoverClass: {
      type: String,
      default: 'itex-popover'
    },
    btnOptions: {
      type: Array,
      default() {
        return [
          {
            label: i18n.t('复制')
          },
          {
            label: i18n.t('粘贴')
          },
          {
            label: i18n.t('剪切')
          }
        ];
      }
    }
  },
  data() {
    return {
      isShowPopover: false
    };
  },
  watch: {

  },
  methods: {
    handleClick(item) {
      this.isShowPopover = false;
      this.$emit('handleClick', item);
    }
  }
};
</script>

<style lang="scss">
.itex-popover{
  min-width: 88px;
  padding: 5px 0;

  .popover-btn{
    width: 100%;
    height: 36px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    padding: 0 10px;

    &:hover{
      background: #f5f7fa;
    }
  }
}
</style>
